const steps = [
  {
    label: 'Create Account',
    value: 'create-account',
  },
  {
    label: 'Patient',
    value: 'patient',
  },
  {
    label: 'Condition',
    value: 'condition',
  },
  {
    label: 'Financials',
    value: 'financials',
  },
  {
    label: 'Community',
    value: 'community',
  },
  {
    label: 'Terms of Service',
    value: 'terms-of-service',
  },
  {
    label: 'Agreements',
    value: 'agreements',
  },
];

export const ProgressBar = ({ selectedStep }) => {
  const selectedStepIndex = steps.findIndex((x) => x.value == selectedStep);
  const className = (i) => {
    return i <= selectedStepIndex ? 'highlighted' : '';
  };
  return (
    <div className='registration-progress-bar'>
      {steps.map((step, i) => {
        return (
          <div key={i} className={className(i)}>
            {step.label}
          </div>
        );
      })}
    </div>
  );
};
